export const getUserLocation = () => ({
  type: "GET_USER_REGION_BY_LOGIN"
});
